const React = require('react');
const Linkify = require('linkifyjs');
const { Link } = require('react-router-dom');

const T = require('prop-types');
const { default: Snackbar } = require('@mui/material/Snackbar');
const { default: SnackbarContent } = require('@mui/material/SnackbarContent');
const { default: Classes } = require('./styles.scss');
const { default: DialogTitle } = require('@mui/material/DialogTitle');
const { default: DialogContent } = require('@mui/material/DialogContent');
const { default: DialogContentText } = require('@mui/material/DialogContentText');
const { default: DialogActions } = require('@mui/material/DialogActions');
const { default: Button } = require('@mui/material/Button');
const { default: Dialog } = require('@mui/material/Dialog');
const { default: styled } = require('styled-components');
const { transient$Props } = require('utils/styles');

const {
    ELEMENT_IDS,
    MAIN_FOOTER_HEIGHT
} = require('utils/constants');

const { useEffect, useCallback } = React;

const { context } = require('app-context');

const {
    selectors: { all: selectors }
} = context;

const AUTOHIDE_DURATION = 4000;

const internals = {};

module.exports = function AppSnackbar(props) {

    const {
        style = {},
        message,
        open,
        actionLabel,
        onRequestClose,
        popUpTitle,
        displayType,
        replaceLinksWithHere,
        onActionClick, // eslint-disable-line no-unused-vars
        ...others
    } = props;

    const {
        StyledSnackbar,
        StyledSnackbarContent,
        renderLinks
    } = internals;

    const handlePopUpActionClick = () => {

        onRequestClose();
        props?.onActionClick();
    };

    const reqClose = (_evt, reason) => {

        if (reason === 'clickaway') {
            clearTimeout(internals.timeoutId);
        }

        onRequestClose();
    };

    const bottomTabsOnPage = document.getElementById(ELEMENT_IDS.appBottomTabs);
    const bottomButtonOnPage = document.getElementById(ELEMENT_IDS.bottomButton);
    const chatTextfieldOnPage = document.getElementById(ELEMENT_IDS.chatTextfield);

    let bottomDistance = MAIN_FOOTER_HEIGHT + 16;

    if ((bottomTabsOnPage && bottomButtonOnPage) || (bottomTabsOnPage && chatTextfieldOnPage)) {
        bottomDistance += 72;
    }

    useEffect(() => {

        if (open) {

            clearTimeout(internals.timeoutId);

            if (displayType !== 'popUp') {
                internals.timeoutId = setTimeout(() => {

                    onRequestClose();
                }, AUTOHIDE_DURATION);
            }
        }
        else {
            internals.initFocus = false;
        }
    }, [open]);

    const contentsRef = useCallback((node) => {

        if (node && !internals.initFocus) {
            internals.initFocus = true;
            node.focus();
        }
    }, []);

    const escListener = (evt) => {

        if (evt.key === 'Escape') {
            onRequestClose(evt);
        }
    };

    return displayType !== 'popUp' ? <div>
        <StyledSnackbar
            $bottomDistance={bottomDistance}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
            }}
            open={open}
            className={Classes.snackbar}
            style={style}
            onClose={reqClose}
            {...others}
        >
            <StyledSnackbarContent message={message} />
        </StyledSnackbar>
    </div> : <Dialog
        open={open}
        onKeyDown={escListener}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
    >
        <div ref={contentsRef} tabIndex={0} data-focus-outline='radius:15'>
            <DialogTitle id='alert-dialog-title'>{popUpTitle}</DialogTitle>
            <DialogContent>
                <DialogContentText id='alert-dialog-description'>
                    {replaceLinksWithHere ? renderLinks(message, onRequestClose) : message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={handlePopUpActionClick}
                    color='primary'
                    data-focus-outline='radius:40,padding:3'
                >
                    {actionLabel}
                </Button>
            </DialogActions>
        </div>
    </Dialog>;
};

module.exports.propTypes = {
    style: T.object,
    bodyStyle: T.object,
    message: T.string,
    open: T.bool,
    displayType: T.string,
    replaceLinksWithHere: T.bool,
    popUpTitle: T.string,
    actionLabel: T.string,
    onActionClick: T.func,
    onRequestClose: T.func,
    bottom: T.number
};

internals.renderLinks = (message = '', onRequestClose) => {

    const { getSameHostPath } = internals;
    const links = Linkify.find(message).filter(({ type }) => type === 'url');
    const parts = [];
    let position = 0;

    links.forEach(({ start, end, href, value }, index) => {

        const url = /^www\./i.test(value) ? href.replace(/^http:\/\//, 'https://') : href;
        const sameHostPath = getSameHostPath(url);

        parts.push(message.slice(position, start));
        parts.push(sameHostPath ?
            <Link key={`${start}-${index}`} to={sameHostPath} onClick={onRequestClose}>here</Link> :
            <a key={`${start}-${index}`} href={url} target='_blank' rel='noopener noreferrer'>here</a>);
        position = end;
    });

    parts.push(message.slice(position));

    return parts;
};

internals.getSameHostPath = (href) => {

    try {
        const url = new URL(href);

        if (url.host !== window.location.host || !['http:', 'https:'].includes(url.protocol)) {
            return null;
        }

        return `${url.pathname}${url.search}${url.hash}`;
    }
    catch (err) {
        return null;
    }
};

internals.StyledSnackbar = styled(Snackbar, transient$Props)`
    display: flex;
    bottom: calc(var(--safezonebottom) + ${({ $bottomDistance }) => $bottomDistance}px);
    align-items: center;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    height: auto;
    text-align: center;
    line-height: 25px;
    padding: 12px 24px;
    white-space: pre-line;
    color: #ffffff;
`;

internals.StyledSnackbarContent = styled(SnackbarContent)`
    text-align: center;
    justify-content: center;
    align-items: center;
    white-space: pre-line;
    background: rgba(0, 0, 0, 0.87);
    color: #ffffff;
`;
